module.exports = __webpack_public_path__ + "assets/img/icon-dongfangtoutiao.75d89e00.png";